import { ICellRendererParams } from '@ag-grid-community/core'
import { generateMdiIcon } from '@helios/ag-grid-config'
import { Job, JobStatus } from '../model/job.model'

const JobStatusIcons = {
  [JobStatus.READY]: generateMdiIcon('mdi-timer-sand'),
  [JobStatus.AWAITING_ACKNOWLEDGEMNET]: generateMdiIcon('mdi-clock-outline'),
  [JobStatus.RUNNING]: generateMdiIcon('mdi-play'),
  [JobStatus.FINISHED]: generateMdiIcon('mdi-check-circle', ['text-success']),
  [JobStatus.FAILED]: generateMdiIcon('mdi-alert-circle', ['text-danger']),
  [JobStatus.INDETERMINATE]: generateMdiIcon('mdi-help-box', ['text-danger']),
  [JobStatus.INVALID]: generateMdiIcon('mdi-cancel', ['text-danger']),
}

export const jobStatusCellRenderer = (params: ICellRendererParams) => {
  const data = params.data as Job

  if (!data) return ''

  return JobStatusIcons[data.status]
}
